import { ArticoliMatricola } from './articoli-matricola';

export class DettaglioMovimento {    
  idArticolo : number;
  qta : number;
  cambio: boolean = true;
  descrizione: string;
  codice: string;
  idTipoArticolo: number;
  listMatricoleConsegna: ArticoliMatricola[];
  listMatricoleRitiro: ArticoliMatricola[];
  listMatricoleConsegnaInserite: ArticoliMatricola[];
  usaMatricola:boolean;
  matricoleConvalidate: boolean;
  matricola?: string;
  componenteFiglio?: boolean = false; //Usato solo per la consegna guidata (Visualizzazione)
  kit?: boolean = false; //Usato solo per la consegna guidata (Visualizzazione)
  dataInserimento: Date; //Usato solo per la consegna guidata (Visualizzazione)
}